import { ref, onMounted } from 'vue';
import usuariosService from '@/services/admin/bases/usuariosService';

/**
 * Composable para obtener la información de pago (tarjeta) de un usuario en admin.
 *
 * @param {import('vue').Ref|string|number} listaId
 * @param {import('vue').Ref|string|number} userId
 * @param {string} tid
 */
export function useInformacionPago(listaId, userId, tid) {
    const loading = ref(false);
    const tarjeta = ref(null);
    const error = ref(null);

    const infoEncontrada = () => !!tarjeta.value;

    /**
     * Resuelve el valor actual de un parámetro que puede ser ref o valor directo.
     */
    function resolveParam(param) {
        return param && typeof param === 'object' && 'value' in param
            ? param.value
            : param;
    }

    async function fetchInfoPago() {
        const resolvedListaId = resolveParam(listaId);
        const resolvedUserId = resolveParam(userId);

        if (!resolvedListaId || !resolvedUserId) {
            error.value = 'Faltan parámetros lista_id o user_id';
            return;
        }

        loading.value = true;
        error.value = null;

        try {
            const result = await usuariosService.getInfoPago({
                userId: resolvedUserId,
                tid,
                lista_id: resolvedListaId,
            });

            if (result?.titular && result?.panVuePayCard) {
                tarjeta.value = {
                    titular: result.titular,
                    panVuePayCard: result.panVuePayCard,
                    mesCaducidad: result.mesCaducidad,
                    anoCaducidad: result.anoCaducidad,
                };
            } else {
                tarjeta.value = null;
            }
        } catch (err) {
            console.error('Error al cargar info de pago:', err);
            error.value = err.message || 'Error al cargar la información de pago';
        } finally {
            loading.value = false;
        }
    }

    onMounted(() => {
        fetchInfoPago();
    });

    return {
        loading,
        tarjeta,
        error,
        infoEncontrada,
        fetchInfoPago,
    };
}
